import React from 'react';

export default function Bag(props) {
  const styles = props.height ? { height: props.height } : null;
  return (
    <svg
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 35 42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={styles}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-15.000000, -249.000000)" fill="#000">
          <g transform="translate(0.000000, 249.000000)">
            <g transform="translate(15.000000, 0.000000)">
              <path
                d="M33.25,42 L1.75,42 C0.784875,42 0,41.215125 0,40.25 L0,8.75 C0,7.784875 0.784875,7 1.75,7 L11.375,7 L11.375,3.5 C11.375,1.56975 12.94475,0 14.875,0 L20.125,0 C22.05525,0 23.625,1.56975 23.625,3.5 L23.625,7 L33.25,7 C34.215125,7 35,7.784875 35,8.75 L35,40.25 C35,41.215125 34.215125,42 33.25,42 Z M21.875,3.5 C21.875,2.534875 21.090125,1.75 20.125,1.75 L14.875,1.75 C13.909875,1.75 13.125,2.534875 13.125,3.5 L13.125,7 L21.875,7 L21.875,3.5 Z M23.625,8.75 L23.625,11.375 C23.625,11.858 23.233,12.25 22.75,12.25 C22.267,12.25 21.875,11.858 21.875,11.375 L21.875,8.75 L13.125,8.75 L13.125,11.375 C13.125,11.858 12.733,12.25 12.25,12.25 C11.767,12.25 11.375,11.858 11.375,11.375 L11.375,8.75 L1.75,8.75 L1.75,40.25 L33.247375,40.25 L33.25,8.75 L23.625,8.75 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/order.js